import React from 'react';
import xClass from 'utils/xClass';
import useInvisibler from 'decorators/Invisibler';
import {TIME_BEFORE_UI_FADES} from 'constants';

/* type Props = {
	unknownTitle: string,
	work: Work,
	works: [Work]
}; */

const Credits = ({
	work,
	hideForIds = ["about", "thankyou", "ty"],
	unknownTitle = "title unknown"
}) => {
	const invisible = useInvisibler({
		delay: TIME_BEFORE_UI_FADES,
		visibleOnPropsChange: false
	});

	const titleUnknown = (title) => {
		return title.toLowerCase() == unknownTitle;
	};

	const formatYear = (year) => {
		if (year && !year.includes('Unknown') && year !== "9999") {
			return `(${year})`;
		}
		return null;
	};

	const sizeMedium = (medium, size) => {
		let sizeMedium = [];
		if (size && !size.includes('unknown')) {
			sizeMedium.push(size);
		}
		if (medium && !medium.includes('Unknown')) {
			sizeMedium.push(medium);
		}
		return sizeMedium.length ? sizeMedium.join(', ') : null;
	};

	const getHTML = (str) => {
		return {__html: str};
	};

	if (!work) {
		return null;
	}

	const { artist, title, additional_credits, id, year, medium, size } = work;

	if (hideForIds.includes(id)) {
		return null;
	}
	if (!artist) {
		return null;
	}

	let creditElements = [];

	if (artist) {
		creditElements.push(
			<span key="artist" className="artist">
				{artist}
			</span>
		);
	}

	if (title && !titleUnknown(title)) {
		creditElements.push(
			<span
				key="title"
				className="title"
				dangerouslySetInnerHTML={getHTML(title)}
			/>
		);
	}

	let moreInfo = [
		sizeMedium(medium, size),
		formatYear(year)
	].filter(x => x);

	if (moreInfo.length) {
		creditElements.push(
			<span
				key="more-info"
				className="size-medium"
				dangerouslySetInnerHTML={getHTML(moreInfo.join(' '))}
			/>
		);
	}

	if (additional_credits) {
		creditElements.push(
			<span
				key="additional-credits"
				className="additional-credits"
				dangerouslySetInnerHTML={getHTML(additional_credits)}
			/>
		);
	}

	let withBreaks = [];
	for (var i = 0; i < creditElements.length; i++) {
		withBreaks.push(creditElements[i]);
		if (i < creditElements.length - 1) {
			withBreaks.push(<br key={`break-${i}`}/>);
		}
	}

	return (
		<div className={xClass("credits", {invisible})}>
			{withBreaks}
		</div>
	);
};

export default Credits;